// extracted by mini-css-extract-plugin
export default {"salesRow":"DashboardAppointments_salesRow__sHgy5","metricsGrid":"DashboardAppointments_metricsGrid__O2fKM"};